import { createSlice } from '@reduxjs/toolkit';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
// Auth initial state
const initialState: {
  lastUserID: number;
  activeSessionsSortBy: string;
  sessionsHistorySort: {
    sortBy: string;
    order: 'asc' | 'desc';
  };
  tradesSort: {
    sortBy: string;
    order: 'asc' | 'desc';
  };
  balanceHidden: boolean;
  defaultAffiliateCampaign: string;
} = {
  lastUserID: 0,
  activeSessionsSortBy: 'latest',
  sessionsHistorySort: {
    sortBy: 'endAt',
    order: 'desc',
  },
  tradesSort: {
    sortBy: 'openTime',
    order: 'desc',
  },
  balanceHidden: false,
  defaultAffiliateCampaign: 'default',
};

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    // --------------------------------------------------------------
    changeActiveSessionOrder(state, action) {
      // 'latest' | 'oldest' | 'highest_pnl' | 'lowest_pnl' | 'highest_roi' | 'lowest_roi'
      if (
        ['latest', 'oldest', 'highest_pnl', 'lowest_pnl', 'highest_roi', 'lowest_roi'].includes(
          action.payload
        )
      ) {
        state.activeSessionsSortBy = action.payload;
      }
    },
    // --------------------------------------------------------------
    changeSessionsHistorySort(state, action) {
      if (
        ['endAt', 'startMargin', 'startAt', 'duration', 'totalPnlAmount'].includes(
          action.payload.sortBy
        )
      ) {
        state.sessionsHistorySort = {
          sortBy: action.payload.sortBy,
          order: ['asc', 'desc'].includes(action.payload.order) ? action.payload.order : 'desc',
        };
      }
    },
    changeTradesSort(state, action) {
      if (['side', 'symbol', 'openTime', 'closeTime', 'pnl'].includes(action.payload.sortBy)) {
        state.tradesSort = {
          sortBy: action.payload.sortBy,
          order: ['asc', 'desc'].includes(action.payload.order) ? action.payload.order : 'desc',
        };
      }
    },
    toggleBalanceHidden(state) {
      state.balanceHidden = !state.balanceHidden;
    },
    setDefaultAffiliateCampaign(state, action) {
      state.defaultAffiliateCampaign = action.payload;
    },
    setNewUserID(state, action) {
      // Check if the same id
      if (state.lastUserID === action.payload) {
        return;
      } else {
        // Reset all state
        state = {
          ...initialState,
          lastUserID: action.payload,
        };
      }
    },
  },
});

// Reducer
export default slice.reducer;

export function changeActiveSessionOrder(activeSessionsSortBy: string) {
  return async () => {
    dispatch(slice.actions.changeActiveSessionOrder(activeSessionsSortBy));
  };
}

export function changeSessionsHistorySort(sortBy: string, order: string) {
  return async () => {
    dispatch(slice.actions.changeSessionsHistorySort({ sortBy, order }));
  };
}

export function changeTradesSort(sortBy: string, order: 'desc' | 'asc') {
  return async () => {
    dispatch(slice.actions.changeTradesSort({ sortBy, order }));
  };
}

export function toggleBalanceHidden() {
  return async () => {
    dispatch(slice.actions.toggleBalanceHidden());
  };
}

export function setDefaultAffiliateCampaign(defaultAffiliateCampaign: string) {
  return async () => {
    dispatch(slice.actions.setDefaultAffiliateCampaign(defaultAffiliateCampaign));
  };
}

export function setNewUserID(lastUserID: number) {
  return async () => {
    dispatch(slice.actions.setNewUserID(lastUserID));
  };
}
